export default "__VITE_ASSET__C4WJ9PQ8__"